<template>
  <a-spin :spinning="loading">
    <div :bordered="false">
      <div style="border: 1px solid rgb(235, 237, 240)">
        <a-page-header
          style="border: 0px solid rgb(235, 237, 240)"
          title="项目信息"
          @back="() => this.$router.back()"
        />
        <a-descriptions style="margin-top: 10px; margin-left: 20px;" v-if="projectInfo.project">
          <a-descriptions-item label="项目编号">
            {{ projectInfo.project[0].number }}
          </a-descriptions-item>
          <a-descriptions-item label="采销全流程">
            {{ projectInfo.project[0].name }}
          </a-descriptions-item>
          <a-descriptions-item label="主体企业">
            {{ projectInfo.project[0].host_corporation }}
          </a-descriptions-item>
          <a-descriptions-item label="交易品种">
            {{ projectInfo.project[0].category }}
          </a-descriptions-item>
          <a-descriptions-item label="信用">
            {{ (projectInfo.project[0].credit).toFixed(2) | numberFormat }}
          </a-descriptions-item>
          <a-descriptions-item label="现金">
            {{ (projectInfo.project[0].cash).toFixed(2) | numberFormat }}
          </a-descriptions-item>
          <a-descriptions-item label="起止时间">
            {{ projectInfo.project[0].start_date }} 至 {{ projectInfo.project[0].end_date }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-if="sortedProjectContentList">
        <div v-for="(item) in sortedProjectContentList" :key="(item.id + item.content_type)">
          <template v-if="item.content_type === 'sell_contract'">
            <SellContractInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-if="item.content_type === 'customs_declaration_in'">
            <CustomsDeclarationInInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-if="item.content_type === 'customs_declaration_out'">
            <CustomsDeclarationOutInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-if="item.content_type === 'logistics'">
            <LogisticsInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-if="item.content_type === 'contract'">
            <ContractInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-if="item.content_type === 'guarantee_contract'">
            <GuaranteeContractInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'material'">
            <MaterialInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'inventory'">
            <InventoryInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'inventory_adjustment'">
            <InventoryAdjustmentInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'payment'">
            <PaymentInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'collection'">
            <CollectionInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'fapiao'">
            <FaPiaoInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'credit_letter'">
            <CreditLetterInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'credit_letter_repayment'">
            <CreditLetterRepaymentInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'cost'">
            <CostInfo :item="item" :index="-1" :edit="false" @handleArchived="handleArchived" @handleEditRecord="handleEditRecord"/>
          </template>
          <template v-else-if="item.content_type === 'settlement'">
            <SettlementInfo
              :item="item"
              :index="-1"
              :edit="false"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
            />
          </template>
        </div>
        <a-drawer
          title="库存"
          placement="right"
          :closable="false"
          v-if="visibleDrawer"
          :visible="visibleDrawer"
          @close="onClose"
          width="500">
          <div v-if="inventoryAdjustmentObj !== undefined">
            <span class="desc_item_drawer">仓库：{{ inventoryAdjustmentObj.warehouse }}</span><br>
            <span class="desc_item_drawer">数量：{{ inventoryAdjustmentObj.count | numberFormat }}</span><br>
            <span class="desc_item_drawer">单位：{{ $Dictionaries.unit[inventoryAdjustmentObj.unit] === undefined ? '-' : $Dictionaries.unit[inventoryAdjustmentObj.unit] }}</span><br>
            <span class="desc_item_drawer">预估人民币单价：{{ (inventoryAdjustmentObj.unit_price_cny).toFixed(2) | numberFormat }} </span><br>
            <span class="desc_item_drawer">已开启审批：{{ inventoryAdjustmentObj.is_approval_needed ? '是' : '否' }}</span><br>
            <span class="desc_item_drawer">审批状态：<span :class="statusText[inventoryAdjustmentObj.status < 0 ? 0 : inventoryAdjustmentObj.status][0]">{{ inventoryAdjustmentObj.is_approval_needed ? ($Dictionaries.approval_result[inventoryAdjustmentObj.status] ? $Dictionaries.approval_result[inventoryAdjustmentObj.status] : '无') : un_approval_needed_text }}</span></span><br>
            <span class="desc_item_drawer">是否已调整：{{ inventoryAdjustmentObj.is_adjustment ? '是' : '否' }}</span><br>
            <span class="desc_item_drawer">已存档：{{ inventoryAdjustmentObj.is_archived ? '是' : '否' }}</span><br>
            <span class="desc" v-if="inventoryAdjustmentObj.create_by">创建人：{{ inventoryAdjustmentObj.create_by }}</span>
            <span class="desc_item_drawer">创建时间：{{ inventoryAdjustmentObj.create_time | dayjs }}</span>
            <div v-if="false">
              <a-collapse :bordered="false">
                <template #expandIcon="props">
                  <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
                </template>
                <a-collapse-panel key="1" header="附件" :style="customStyle" v-if="inventoryAdjustmentObj.attachment.length > 0">
                  <a v-for="(attachment) in inventoryAdjustmentObj.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc_item_drawer"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </a-drawer>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import { project_detail } from '@/api/trade_project'
import {
  credit_letter_list,
  credit_letter_update
} from '@/api/trade_credit_letter'
import SellContractInfo from '../../../../project/modules/SellContractInfo'
import CustomsDeclarationInInfo from '../../../../project/modules/CustomsDeclarationInInfo'
import CustomsDeclarationOutInfo from '../../../../project/modules/CustomsDeclarationOutInfo'
import LogisticsInfo from '../../../../project/modules/LogisticsInfo'
import ContractInfo from '../../../../project/modules/ContractInfo'
import GuaranteeContractInfo from '../../../../project/modules/GuaranteeContractInfo'
import MaterialInfo from '../../../../project/modules/MaterialInfo'
import InventoryInfo from '../../../../project/modules/InventoryInfo'
import InventoryAdjustmentInfo from '../../../../project/modules/InventoryAdjustmentInfo'
import PaymentInfo from '../../../../project/modules/PaymentInfo'
import CollectionInfo from '@/views/a-trade/project/modules/CollectionInfo'
import FaPiaoInfo from '@/views/a-trade/project/modules/FaPiaoInfo'
import CreditLetterInfo from '@/views/a-trade/project/modules/CreditLetterInfo'
import CreditLetterRepaymentInfo from '@/views/a-trade/project/modules/CreditLetterRepaymentInfo'
import CostInfo from '../../../../project/modules/CostInfo'
import SettlementInfo from '../../../../project/modules/SettlementInfo'
import { credit_letter_detail_update } from '@/api/trade_credit_letter_detail'
import { sell_contract_list } from '@/api/trade_sell_contract'
import { contract_list } from '@/api/trade_contract'
import { guarantee_contract_list } from '@/api/trade_guarantee_contract'
import { inventory_list } from '@/api/trade_inventory'
import { inventory_adjustment_list } from '@/api/trade_inventory_adjustment'
import { payment_list } from '@/api/trade_payment'
import { collection_list } from '@/api/trade_collection'
import { fapiao_list } from '@/api/trade_fapiao'
import { credit_letter_repayment_list } from '@/api/trade_credit_letter_repayment'
import { project_cost_list } from '@/api/trade_project_cost'
import { settlement_list } from '@/api/trade_settlement'
import { logistics_list } from '@/api/trade_logistics'
import { customs_declaration_in_list, customs_declaration_out_list } from '@/api/trade_customs_declaration'
import { project_material_list } from '@/api/trade_project_material'

export default {
  name: 'TableList',
  components: {
    STable,
    SellContractInfo,
    CustomsDeclarationInInfo,
    CustomsDeclarationOutInfo,
    LogisticsInfo,
    ContractInfo,
    GuaranteeContractInfo,
    MaterialInfo,
    InventoryInfo,
    InventoryAdjustmentInfo,
    PaymentInfo,
    CollectionInfo,
    FaPiaoInfo,
    CreditLetterInfo,
    CreditLetterRepaymentInfo,
    CostInfo,
    SettlementInfo
  },
  data () {
    return {
      loading: true,
      visibleDrawer: false,
      drawerLoading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      un_approval_needed_text: '未开启审批',
      currentComponent: '',
      // 创建窗口控制
      inventoryAdjustmentVisible: false,
      visible: false,
      mdl: {},
      inventoryMdl: {},
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      },
      inventoryAdjustmentObj: undefined,
      projectInfo: {},
      projectContentList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '主体企业',
          dataIndex: 'host_corporation'
        },
        {
          title: '交易品种',
          dataIndex: 'category'
        },
        {
          title: '编号',
          dataIndex: 'number'
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '信用',
          dataIndex: 'credit'
        },
        {
          title: '现金',
          dataIndex: 'cash'
        },
        {
          title: '起止时间',
          dataIndex: 'start_date',
          customRender: (text, record) => text === '1970-01-01' ? '' : text + '到' + record.end_date
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.mdl.id = this.$route.query.record
    this.projectDetailInfo()
  },
  computed: {
    sortedProjectContentList () {
      return [...this.projectContentList].sort((a, b) => new Date(a.create_time) - new Date(b.create_time))
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd (component) {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: this.projectInfo.project[0].number + hours + minutes }
      this.currentComponent = component
      this.visible = true
    },
    handleAddSellContract () {
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleInventoryAdjustAddCancel () {
      this.inventoryAdjustmentVisible = false
      const form = this.$refs.inventoryAdjustmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id })
    },
    handleClient (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id + '/client', query: { record: record.host_corporation } })
    },
    handleRemark (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id + '/remark', query: { record: record.host_corporation } })
    },
    handleDetail (record) {
      console.log(record)
    },
    handleDelete (record, type) {
      this.loading = true
      this.deleteByType(type)(record.id).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        } else {
          this.loading = false
        }
      })
    },
    handleArchived (record, type) {
      this.loading = true
      this.archivedByType(type)({ ids: [record.id], is_archived: true }).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        } else {
          this.loading = false
        }
      })
    },
    getApproveDataByType (type) {
      if (type === 'trade_sell_contract') {
        return sell_contract_list
      } else if (type === 'trade_contract') {
        return contract_list
      } else if (type === 'trade_inventory') {
        return inventory_list
      } else if (type === 'trade_inventory_adjustment') {
        return inventory_adjustment_list
      } else if (type === 'trade_payment') {
        return payment_list
      } else if (type === 'trade_collection') {
        return collection_list
      } else if (type === 'trade_fapiao') {
        return fapiao_list
      } else if (type === 'trade_credit_letter') {
        return credit_letter_list
      } else if (type === 'trade_credit_letter_repayment') {
        return credit_letter_repayment_list
      } else if (type === 'trade_guarantee_contract') {
        return guarantee_contract_list
      } else if (type === 'trade_customs_declaration_in') {
        return customs_declaration_in_list
      } else if (type === 'trade_customs_declaration_out') {
        return customs_declaration_out_list
      } else if (type === 'trade_logistics') {
        return logistics_list
      } else if (type === 'trade_cost') {
        return project_cost_list
      } else if (type === 'trade_settlement') {
        return settlement_list
      } else if (type === 'trade_material') {
        return project_material_list
      }
    },
    projectDetailInfo () {
      if (!this.loading) {
        this.loading = true
      }
      this.getApproveDataByType(this.$route.query.type)({ id: this.$route.query.data_id }).then(res => {
        console.log(res.data)
        if (res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
          project_detail({ project_id: res.data.entries[0].project_id }).then(res => {
            console.log(res)
            this.projectInfo = res.data
            this.projectContentList = []
            if (this.$route.query.type === 'trade_sell_contract') {
              this.projectContentList.push(...this.projectInfo.sell_contract_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'sell_contract'
                return item
              }))
            } else if (this.$route.query.type === 'trade_contract') {
              this.projectContentList.push(...this.projectInfo.contract_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'contract'
                return item
              }))
            } else if (this.$route.query.type === 'trade_material') {
              this.projectContentList.push(...this.projectInfo.material_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'material'
                return item
              }))
            } else if (this.$route.query.type === 'trade_inventory') {
              this.projectContentList.push(...this.projectInfo.inventory_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'inventory'
                return item
              }))
            } else if (this.$route.query.type === 'trade_inventory_adjustment') {
              const inventory_adjustment_list = this.projectInfo.inventory_adjustment_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'inventory_adjustment'
                return item
              })
              this.projectContentList.push(...inventory_adjustment_list)
            } else if (this.$route.query.type === 'trade_payment') {
              this.projectContentList.push(...this.projectInfo.payment_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'payment'
                return item
              }))
            } else if (this.$route.query.type === 'trade_collection') {
              this.projectContentList.push(...this.projectInfo.collection_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'collection'
                return item
              }))
            } else if (this.$route.query.type === 'trade_fapiao') {
              this.projectContentList.push(...this.projectInfo.fapiao_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'fapiao'
                return item
              }))
            } else if (this.$route.query.type === 'trade_credit_letter') {
              this.projectContentList.push(...this.projectInfo.credit_letter_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'credit_letter'
                return item
              }))
            } else if (this.$route.query.type === 'trade_credit_letter_repayment') {
              this.projectContentList.push(...this.projectInfo.credit_letter_repayment_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'credit_letter_repayment'
                return item
              }))
            } else if (this.$route.query.type === 'trade_customs_declaration_in') {
              this.projectContentList.push(...this.projectInfo.customs_declaration_in_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'customs_declaration_in'
                return item
              }))
            } else if (this.$route.query.type === 'trade_customs_declaration_out') {
              this.projectContentList.push(...this.projectInfo.customs_declaration_out_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'customs_declaration_out'
                return item
              }))
            } else if (this.$route.query.type === 'trade_guarantee_contract') {
              this.projectContentList.push(...this.projectInfo.guarantee_contract_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'guarantee_contract'
                return item
              }))
            } else if (this.$route.query.type === 'trade_logistics') {
              this.projectContentList.push(...this.projectInfo.logistics_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'logistics'
                return item
              }))
            } else if (this.$route.query.type === 'trade_cost') {
              this.projectContentList.push(...this.projectInfo.cost_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'cost'
                return item
              }))
            } else if (this.$route.query.type === 'trade_settlement') {
              this.projectContentList.push(...this.projectInfo.settlement_list.filter(item => {
                return item.id === Number(this.$route.query.data_id)
              }).map(item => {
                item.content_type = 'settlement'
                return item
              }))
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    handleEditRecord (record, type) {
      this.$router.push({ path: '/trade/' + type + '/' + record.id, query: { record: record.host_corporation } })
    },
    handleCreditLetterDone (record) {
      if (record.is_approval_needed && record.status === 1) {
        this.$message.warning('审批还未结束')
        return
      }
      credit_letter_update({ is_done: true }, record.id).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        }
      })
    },
    handleCreditLetterDetailDone (record) {
      credit_letter_detail_update({ is_done: true }, record.id).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        }
      })
    },
    getInventoryNumber (inventory_id) {
      let index = 0
      this.sortedProjectContentList.forEach((item, i) => {
        if (item.id === inventory_id && item.content_type === 'inventory') {
          index = i + 1
        }
      })
      return index
    },
    watchInventory (record) {
      console.log(record)
      const matchInventory = this.projectInfo.inventory_list.filter(item => {
        return item.id === record.inventory_id
      }).map(item => {
        item.content_type = 'inventory'
        return item
      })
      console.log(matchInventory)
      if (matchInventory !== undefined && matchInventory.length > 0) {
        this.inventoryAdjustmentObj = matchInventory[0]
        this.visibleDrawer = true
        console.log(this.inventoryAdjustmentObj)
      }
    },
    onClose () {
      this.visibleDrawer = false
    }
  }
}
</script>
<style scoped>
  .desc {
    padding-left: 20px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
  }
  .row_item {
    border-bottom: 1px solid #eeeeee;
    padding: 10px 20px;
    background-color: #f7f7f7;
    margin-top: 5px;
    border-radius: 10px;
  }
  .content {
    color: #00A0E9;
    font-weight: bolder
  }
  .none {
    color: #333333;
  }
  .waiting {
    color: yellowgreen;
  }
  .pass {
    color: green;
  }
  .un_pass {
    color: red;
  }
  .desc_item_drawer {
    padding-left: 20px;
    height: 50px;
    line-height: 50px;
  }
</style>
